const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_BASE_URL = {
  LOGIN: `${BASE_URL}/auth`,
  SIGNUP: `${BASE_URL}/auth/signup`,
  ENTIDADE: `${BASE_URL}/entidade`,
  EMISSOR: `${BASE_URL}/emissor`,
  USUARIO: `${BASE_URL}/usuario`,
  VINCULO: `${BASE_URL}/vinculo`,
  UF: `${BASE_URL}/uf`,
  MUNICIPIO: `${BASE_URL}/municipio`,
  EFISCO_PE: `${BASE_URL}/efiscope`,
  UNIDADE_MEDIDA: `${BASE_URL}/unidade_medida`,
  MODALIDADE: `${BASE_URL}/modalidades`,
  CONTRATO: `${BASE_URL}/contratos`,
  CONTRATO_ITEM: `${BASE_URL}/contrato_itens`,
  CONTRATO_PEDIDO: `${BASE_URL}/contrato_pedidos`,
  CONTRATO_PEDIDO_ITEM: `${BASE_URL}/contrato_pedido_itens`,
  FORNECEDOR: `${BASE_URL}/fornecedores`,
  IMAGEM: `${BASE_URL}/imagem`,
  DESCRICAO_ENTREGA: `${BASE_URL}/descricao-entrega`,
  ARP: `${BASE_URL}/arps`,
  ARP_ITEM: `${BASE_URL}/arp_itens`,
  ARP_ORDEM: `${BASE_URL}/arp_ordens`,
  ARP_ORDEM_ITEM: `${BASE_URL}/arp_ordem_itens`,
  CNPJ_PROXY: `${BASE_URL}/cnpj`,
  PRE_EMPENHO: `${BASE_URL}/pre-empenhos`,
  COMPRA_DIRETA: `${BASE_URL}/compras-direta`,
  COMPRA_DIRETA_ITEM: `${BASE_URL}/compras-direta`,
   ELEMENTO_DESPESA: `${BASE_URL}/elemento-despesa`,
  SUBELEMENTO_DESPESA: `${BASE_URL}/subelemento-despesa`,
  ACAO_GOVERNAMENTAL: `${BASE_URL}/acao-governamental`,
  FONTE_RECURSO: `${BASE_URL}/fonte-recurso`,
  CNAE: `${BASE_URL}/cnae`,
  BANCO: `${BASE_URL}/banco`,
  NATUREZA_JURIDICA: `${BASE_URL}/natureza-juridica`,
  PARAMETRO: `${BASE_URL}/parametros`,
};
